/* VeltronShop 2027 - accueil immersif : apparitions au defilement, scenes plein ecran, bandeau, barre d'achat mobile.
   Aucune bibliotheque, aucun ecouteur de scroll : uniquement des IntersectionObserver (le defilement reste fluide).
   Si ce script est absent ou en erreur, un filet de securite CSS affiche tout le contenu apres 3,5 s. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var hasIO = 'IntersectionObserver' in window;
  var started = false;

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel));
  }

  function showNow(list) {
    list.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Apparition progressive des textes et images (hors scenes : celles-ci ont leur propre observateur) */
  function reveals() {
    var items = all('.vi-r').filter(function (el) { return !el.closest('.vi-scene'); });
    if (!hasIO) { showNow(items); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Scenes plein ecran : .is-in quand la scene est bien visible, .is-away quand elle est cachee ou recouverte (pause des animations) */
  function scenes() {
    var list = all('.vi-scene');
    if (!list.length) return;
    if (!hasIO) { showNow(list); return; }
    var ratio = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        ratio.set(e.target, e.intersectionRatio);
        if (e.intersectionRatio >= 0.55) e.target.classList.add('is-in');
      });
      list.forEach(function (s, i) {
        var self = ratio.get(s) || 0;
        var next = list[i + 1] ? (ratio.get(list[i + 1]) || 0) : 0;
        s.classList.toggle('is-away', self === 0 || next >= 0.98);
      });
    }, { threshold: [0, 0.25, 0.55, 0.98, 1] });
    list.forEach(function (s) { io.observe(s); });
  }

  /* Bandeau defilant : en pause quand il est hors de l'ecran */
  function tickers() {
    if (!hasIO) return;
    all('.vi-ticker').forEach(function (t) {
      new IntersectionObserver(function (es) {
        t.classList.toggle('is-off', !es[0].isIntersecting);
      }).observe(t);
    });
  }

  /* Barre d'achat mobile : visible apres la couverture, tant qu'aucun bouton d'achat n'est a l'ecran et que le pied de page est hors champ */
  function dock() {
    var bar = doc.querySelector('[data-vi-dock]');
    var hero = doc.querySelector('.vi-hero');
    if (!bar || !hero || !hasIO) return;
    var seen = [];
    var pastHero = false;
    var footerSeen = false;
    function update() {
      bar.classList.toggle('is-on', pastHero && !seen.length && !footerSeen);
    }
    var cta = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = seen.indexOf(e.target);
        if (e.isIntersecting && i < 0) seen.push(e.target);
        if (!e.isIntersecting && i > -1) seen.splice(i, 1);
      });
      update();
    }, { threshold: 0.6 });
    all('[data-vi-cta]').forEach(function (b) { cta.observe(b); });
    new IntersectionObserver(function (es) {
      var r = es[0];
      pastHero = !r.isIntersecting && r.boundingClientRect.bottom < 0;
      update();
    }).observe(hero);
    var footer = doc.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (es) {
        footerSeen = es[0].isIntersecting;
        update();
      }).observe(footer);
    }
  }

  function safe(fn) {
    try { fn(); } catch (err) { /* une fonction en erreur ne doit jamais bloquer les autres */ }
  }

  function init() {
    if (started || !doc.querySelector('.vi')) return;
    started = true;
    safe(reveals);
    safe(scenes);
    root.classList.add('vi-ready');
    safe(tickers);
    safe(dock);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editeur de theme : une section ajoutee ou modifiee s'affiche tout de suite, sans attendre le defilement */
  doc.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (!el || !el.querySelectorAll) return;
    showNow(all('.vi-r, .vi-scene', el));
    started = false;
    init();
  });
})();